import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import {
  DirectoryRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import EmployeeIdTextField from '../../user-details/profile-information/employee-id-textfield';
import WorkPhoneTextField from '../../user-details/profile-information/work-phone-textfield';
import ManagerEmailTextField from '../../user-details/profile-information/manager-email-textfield';
import PrimaryOrganizationSection from '../../user-details/profile-information/primary-organization-section';
import { SectionHeader } from '../../../../shared/section-header';
import { UserFormValues } from '../user-schema';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

interface StepEmployeeInformationProps {
  watch: UseFormWatch<UserFormValues>;
  setValue: UseFormSetValue<UserFormValues>;
  directoryRoles: string[];
}

export default function StepEmployeeInformation({
  directoryRoles,
  watch,
  setValue,
}: StepEmployeeInformationProps) {
  return (
    <Box gap={1}>
      <SectionHeader sx={{ mb: 1 }}>Employee Related</SectionHeader>
      <Stack flexDirection="row" flexWrap="wrap" gap={2} mb={4}>
        <EmployeeIdTextField
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditExternalIds.value
            )
          }
        />
        <WorkPhoneTextField
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditPhoneNumbers.value
            )
          }
        />
        <ManagerEmailTextField
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditRelationships.value
            )
          }
        />
        <Box sx={{ width: 400 }}></Box>
      </Stack>
      <SectionHeader sx={{ mb: 1 }}>Primary Organization</SectionHeader>
      <Stack flexDirection="row" flexWrap="wrap" gap={2}>
        <PrimaryOrganizationSection
          watch={watch}
          setValue={setValue}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditOrganizations.value
            )
          }
        />
        <Box sx={{ width: 400 }}></Box>
      </Stack>
    </Box>
  );
}
